


















































































import { Component, Vue } from "vue-property-decorator";
import { RoleEnum } from "@/store/authentication/types";
import { Action, Getter } from "vuex-class";
import { version } from "@/../package.json";
const namespace: string = "authentication";

    @Component
export default class Sidebar extends Vue {
        @Action("logoutAction", { namespace }) logoutAction: any;
        @Getter("getCurrentUser", { namespace }) getCurrentUser: any;
        @Getter("authorize", { namespace }) authorize: any;

        roles = RoleEnum;

        // local
        onLogout(): void {
            this.logoutAction();
            this.$router.push("/login");
        }

        // computed
        get name(): string {
            return this.getCurrentUser.firstName && this.getCurrentUser.lastName ? `${this.getCurrentUser.firstName} ${this.getCurrentUser.lastName}` : "";
        }

        get appVersion(): string {
            return version;
        }

        get initials(): string {
            let firstNameInitial = "";
            let lastNameInitial = "";
            if (this.getCurrentUser.firstName) firstNameInitial = this.getCurrentUser.firstName.charAt(0);
            if (this.getCurrentUser.lastName) lastNameInitial = this.getCurrentUser.lastName.charAt(0);
            return `${firstNameInitial}${lastNameInitial}`;
        }
}
